import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogCallIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogCall",
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.89 27.06s-.05-.02-.08-.04zm8.66-3.47-3.05-3.04a1.619 1.619 0 0 0-2.28 0l-2.21 2.21c-.19.19-.46.32-.76.32s-.56-.12-.76-.32l-4.54-4.54c-.19-.19-.32-.46-.32-.76s.12-.57.32-.76l2.21-2.21a1.619 1.619 0 0 0 0-2.28l-3.03-3.03c-.29-.29-.69-.46-1.13-.46s-.84.18-1.13.46l-1.14 1.14c-1.42 1.42-1.5 3.85-.49 6.54.12.33.25.66.42.98l.05.11c.96 1.96 2.25 3.73 3.8 5.25 1.51 1.54 3.28 2.83 5.36 3.84.65.31 1.33.57 2.13.79 2.22.63 4.19.36 5.39-.85l1.14-1.14a1.619 1.619 0 0 0 0-2.28l.02.02ZM9.79 7.21H7.5v-2.3c0-.6-.48-1.08-1.08-1.08s-1.08.48-1.08 1.08V7.2H3.06c-.6 0-1.08.48-1.08 1.08s.48 1.08 1.08 1.08h2.29v2.3c0 .6.48 1.08 1.08 1.08s1.08-.48 1.08-1.08V9.37H9.8c.6 0 1.08-.48 1.08-1.08S10.4 7.21 9.8 7.21Z"
    })
  }));
};